import { ComponentRef } from '@angular/core';
import { SettableInputs } from 'src/app/shared/types/inputs-of';

// ComponentRef.setInput takes the input name as a string, so the compiler checks neither the name
// nor the value, and production silently ignores a name the component does not declare. Typing
// the inputs from the ref's component makes both a compile error. A ref whose component type is
// erased (a lazily loaded `Type<SomeInterface>`) has no signal inputs to check against and is
// refused; call setInput directly there and pin the name in a spec.
export function setInputs<C>(componentRef: ComponentRef<C>, inputs: SettableInputs<C>): void {
  for (const [name, value] of Object.entries(inputs)) {
    componentRef.setInput(name, value);
  }
}
